/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    ul: "ul",
    li: "li",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h3, null, "Workshops/Outreach Programs"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "Mainstreet Child Development Center Art Program - ", React.createElement(_components.a, {
    href: "https://www.fairfaxartleague.net"
  }, "Fairfax Art League")), "\n", React.createElement(_components.li, null, "Geormetry Workshop - ", React.createElement(_components.a, {
    href: "https://www.fairfaxartleague.net"
  }, "Fairfax Art League")), "\n", React.createElement(_components.li, null, "Online Painting workshop for children with ", React.createElement(_components.a, {
    href: "https://www.scriptsnscribes.com"
  }, "Scripts 'n' Scribes")), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
